module.exports = __webpack_public_path__ + "static/img/6.b9de413.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/6.png
// module id = KHar
// module chunks = 0